<template>
  <div style="background-color: white; box-shadow: 5px 5px 8px 0px rgba(0, 0, 0, 0.5); margin-top: 75px" class="pt-0 pt-md-5 pb-5">
<!--    <div class="body-spacer"></div>-->
    <div class="top-container container d-flex flex-wrap">
      <div class="top-container-left col-12 col-md-4 d-flex flex-column justify-content-center justify-content-md-start align-items-center align-items-md-start">
        <img class="logo" :src="require('../assets/'+this.image)">
        <div style="padding-top: 20px">
          <div class="top-container-left-title">Timeline</div>
          <div>{{ this.timeline }}</div>
        </div>
        <div style="padding-top: 20px">
          <div class="top-container-left-title">Team</div>
          <div>{{this.team}}</div>
        </div>
      </div>
      <div class="top-container-right col-12 col-md-8 pt-5 pt-md-0">
        <h1>{{this.title}}</h1>
        <TagList :tags="this.tags"/>
        <div class="pt-3 pb-3" style="text-align: justify">{{this.description}}</div>
        <div class="keypoints-container">
          <h2>Keypoints</h2>
          <div v-for="(item, index) in keypoints" :key="index">
            <DiamondList :text="item" :category="tryGetCategoryColor(index)"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TagList from "@/components/TagList";
import DiamondList from "@/components/DiamondList";

export default {
  name: "ProjectOverview",
  components:{
    TagList,
    DiamondList
  },
  props:{
    title:{
      type: String,
      default: "Project Name"
    },
    image:{
      type: String,
      default: 'hc3p/HC3P_Logo.png'
    },
    description:{
      type: String,
      default: "DESCRIPTION"
    },
    keypoints:{
      type: Array,
      default: ()=>["Hallo", "Salut"]
    },
    categories:{
      type: Array,
      default: ()=>["C#", "Mobile"]
    },
    tags:{
      type: Array,
      default: ()=>["C#", "Mobile"]
    },
    timeline:{
      type: String,
      default: "MONTH to MONTH YEAR"
    },
    team:{
      type: String,
      default: "3 Game Designers & 3 Game Arts"
    }
  },
  methods:{
    tryGetCategoryColor(index){
      return this.categories[index]
    }
  }
}
</script>

<style lang="scss" scoped>

@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/mixins";

.body-spacer{
  padding-top: 0px;

  @include media-breakpoint-up(md) {
    padding-top: 70px;
  }
}

.logo{
  width: 200px;

  @include media-breakpoint-up(md) {
    width: 100%;
  }
}

.top-container-left-title{
  font-family: Helvetica;
  font-size: 20px;
  margin: 0px;
  text-align: center;

  @include media-breakpoint-up(md) {
    text-align: left;
    line-height: 1;
  }
}

h1{
  font-family: Helvetica;
  font-size: 2rem;
  margin: 0px;

  @include media-breakpoint-up(md) {
    font-size: 2.5rem;
  }
}

.keypoints-container{
  padding-left: 0px;
  @include media-breakpoint-up(md) {
    padding-left: 40px;
  }
}

ul {
  position: relative;
  list-style: none;
  margin-left: 0px;
  padding-left: 1.7em;
}

ul li{
  font-size: 18px;
  margin: 10px;
}

ul li:before {
  content: "►";
  position: absolute;
  left: 0;
  font-family: Helvetica;
  color: #404040;
}

</style>